import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import PushNotificationBanner from './PushNotificationBanner';
import './PageLayout.css';

/**
 * Wraps Navbar, main content, and Footer in a flex layout
 * so the footer stays at the bottom of the viewport when content is short.
 * Shows push notification permission banner when user is logged in and permission not yet set.
 */
const PageLayout = ({ children }) => {
  return (
    <div className="page-layout">
      <Navbar />
      <PushNotificationBanner />
      <main className="page-layout-main">{children}</main>
      <Footer />
    </div>
  );
};

export default PageLayout;
